import { Pantalla } from './componentes/estructura.js';
import { PantallaAcceso } from './pantallas/Acceso.js';
import { PantallaAlta } from './pantallas/Alta.js';
import { PantallaCola } from './pantallas/Cola.js';
import { PantallaFotos } from './pantallas/Fotos.js';
import { PantallaGrabar } from './pantallas/Grabar.js';
import { PantallaHoy } from './pantallas/Hoy.js';
import { PantallaManual } from './pantallas/Manual.js';
import { PantallaQr } from './pantallas/Qr.js';
import { PantallaRecorrido } from './pantallas/Recorrido.js';
import { PantallaResumen } from './pantallas/Resumen.js';
import { useApp } from './estado/app.js';

/**
 * El conmutador de pantallas.
 *
 * Un `switch` y no un router: son pantallas en línea, la navegación es un
 * asistente y el botón atrás del sistema ya está resuelto en el proveedor con
 * el History API. Lo que se gana es que aquí se ve, de un vistazo, todo lo que
 * la app puede enseñar.
 */
export function App() {
    const { pantalla } = useApp();

    switch (pantalla.n) {
        case 'cargando':
            return <Pantalla />;

        case 'alta':
            return <PantallaAlta token={pantalla.token} />;

        case 'crear_pin':
            return <PantallaAlta token={pantalla.token} />;

        case 'pin':
            return <PantallaAcceso />;

        case 'hoy':
            return <PantallaHoy />;

        case 'qr':
            return <PantallaQr />;

        case 'recorrido':
            return <PantallaRecorrido limpiezaId={pantalla.limpieza} />;

        case 'grabar':
            return <PantallaGrabar limpiezaId={pantalla.limpieza} estanciaId={pantalla.estancia} />;

        case 'fotos':
            return <PantallaFotos limpiezaId={pantalla.limpieza} estanciaId={pantalla.estancia} />;

        case 'resumen':
            return <PantallaResumen limpiezaId={pantalla.limpieza} />;

        case 'cola':
            return <PantallaCola />;

        case 'manual':
            return <PantallaManual />;
    }
}
